import type { ProgramEventFeedback } from 'models';
import { Form, FormActions, Modal, RateInput, Section, TextAreaInput, Title } from 'ui';

export type EventFeedbackConfig = {
  key: string;
  starLabel: string;
  textAreaLabel: string;
  textKey: string;
  title: string;
};

type P<T extends ProgramEventFeedback> = {
  config: EventFeedbackConfig[];
  loading: boolean;
  onCancel: () => void;
  onSubmit: (data: T) => void;
};

const RateEventFeedbackForm = <T extends ProgramEventFeedback>({ config, loading, onCancel, onSubmit }: P<T>) => {
  const [form] = Form.useForm<T>();

  const onFinish = (data: T) => {
    onSubmit(data);
  };

  return (
    <Form<T> form={form} onFinish={onFinish}>
      {config.map((section, index) => (
        <Section key={section.key} lineBottom={false} lineTop={index > 0} paddingBottom={false} paddingTop={index > 0}>
          <Title level={5} marginBottom>
            {section.title}
          </Title>
          <RateInput
            item={{
              label: section.starLabel,
              name: section.key,
              rules: [
                {
                  required: true,
                },
              ],
            }}
          />
          <Form.Item<number> dependencies={[section.key]} noStyle>
            {({ getFieldValue }) =>
              getFieldValue(section.key) < 5 ? (
                <TextAreaInput
                  item={{
                    label: section.textAreaLabel,
                    name: section.textKey,
                  }}
                />
              ) : null
            }
          </Form.Item>
        </Section>
      ))}
      <Modal.HugContent.Footer>
        <FormActions right={{ children: 'Skip', onClick: onCancel }} submit={{ children: 'Send', loading }} />
      </Modal.HugContent.Footer>
    </Form>
  );
};

export default RateEventFeedbackForm;
